import { GET_DRIVER_QUEUE } from '../actions/actionTypes';
import { DriverQueueState } from '../../models/DriverQueue';

const initialState: DriverQueueState = {
  queue: [],
  serving: [],
  whsQueue: [],
  whsServing: [],
  whsWt: 0,
  waitTime: 0,
  importCount: 0,
  exportCount: 0
};

export const driverQueueReducer = (state: DriverQueueState = initialState, action: any) => {

  switch (action.type) {

    case GET_DRIVER_QUEUE:
      return { ...action.data };
    default:
      return state;
  }
};